import React, { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "./Navbar.css";
import ContactModal from "../Contact/ContactModal";
import LoginModal from "../Login/LoginModal";
import logo from "./image.png";
import { FaShoppingCart, FaUser } from "react-icons/fa";

const CustomNavbar = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const navigate = useNavigate();
  const { cartCount } = useCart();

  const handleOpenContactModal = () => setIsContactModalOpen(true);
  const handleCloseContactModal = () => setIsContactModalOpen(false);

  const handleOpenLoginModal = () => setIsLoginModalOpen(true);
  const handleCloseLoginModal = () => setIsLoginModalOpen(false);

  const handleGoToHome = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleScrollTo = (sectionId) => {
    navigate("/");
    setTimeout(() => {
      const section = document.querySelector(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 300);
  };

  return (
    <>
      <header className="custom-header">
        <Navbar expand="lg" className="custom-navbar">
          <Container>
            {/* Logo y nombre */}
            <div className="logo-container" onClick={handleGoToHome} style={{ cursor: "pointer" }}>
              <img src={logo} alt="Deluxe Labs Logo" className="logo-img" />
              <span className="brand-name">Deluxe Labs</span>
            </div>
            {/* Botón de menú */}
            <Navbar.Toggle aria-controls="navbar-nav" />
            <Navbar.Collapse id="navbar-nav">
              <Nav className="mx-auto">
                <Nav.Link onClick={handleGoToHome}>Inicio</Nav.Link>
                <Nav.Link as={NavLink} to="/productos">
                  Productos
                </Nav.Link>
                <Nav.Link onClick={() => handleScrollTo("#sube-tu-diseño")}>
                  Sube tu diseño
                </Nav.Link>
                <Nav.Link onClick={handleOpenContactModal} className="contact-btn">
                  Contáctanos
                </Nav.Link>
                {/* Log in dentro del menú desplegable */}
                <Nav.Link className="nav-link-login" onClick={handleOpenLoginModal}>
                  Log in
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
            {/* Log in y carrito */}
            <div className="user-cart-wrapper">
              <div className="login-wrapper" onClick={handleOpenLoginModal}>
                <FaUser size={20} className="user-icon" />
                <span className="login-text">Log in</span>
              </div>
              <div className="cart-icon-wrapper">
                <div className="cart-icon" onClick={() => navigate("/carrito")}>
                  <FaShoppingCart size={24} />
                  <span className="cart-count">{cartCount}</span>
                </div>
              </div>
            </div>
          </Container>
        </Navbar>
      </header>
      <ContactModal isOpen={isContactModalOpen} onClose={handleCloseContactModal} />
      <LoginModal isOpen={isLoginModalOpen} onClose={handleCloseLoginModal} />
    </>
  );
};

export default CustomNavbar;
